import React from 'react'
import { classNames } from '@resurs-internal/styx-react/lib/utils/helpers'
import styles from './Card.module.scss'

export const Card = ({
  header,
  subheader,
  children,
  className,
  focused = false,
}) => (
  <div className={classNames(styles.card, className, focused && styles.focus)}>
    {header && <div className={styles.header}>{header}</div>}
    {subheader && <div className={styles.subheader}>{subheader}</div>}
    <div className={styles.content}>{children}</div>
  </div>
)
